/**
 * Deterministic seed override for end-to-end tests.
 *
 * Reads `?seed=<int>` from `window.location` and returns the parsed value.
 * Returns `null` when the param is missing, malformed, or out of range.
 *
 * Used by standalone setup so e2e tests get reproducible role layouts.
 * Safe in non-browser environments (returns `null`).
 */
export const getSeedFromQuery = (): number | null => {
  if (typeof window === 'undefined') return null;
  const raw = new URLSearchParams(window.location.search).get('seed');
  if (raw === null) return null;
  const parsed = Number.parseInt(raw, 10);
  if (!Number.isFinite(parsed)) return null;
  if (parsed < 0 || parsed > 0x7fffffff) return null;
  return parsed;
};
